// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeOrganizationInfoDto
 */
export interface IEmployeeOrganizationInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeOrganizationInfoDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeOrganizationInfoDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeOrganizationInfoDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof IEmployeeOrganizationInfoDto
     */
    communication_channels?: Set<IEmployeeOrganizationInfoDtoCommunicationChannelsEnum>;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeOrganizationInfoDtoCommunicationChannelsEnum {
    NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
    EMAIL_SMS = 'EMAIL_SMS',
    DATA_EXPORT = 'DATA_EXPORT'
}


/**
 * Check if a given object implements the IEmployeeOrganizationInfoDto interface.
 */
export function instanceOfIEmployeeOrganizationInfoDto(value: object): value is IEmployeeOrganizationInfoDto {
    return true;
}

export function IEmployeeOrganizationInfoDtoFromJSON(json: any): IEmployeeOrganizationInfoDto {
    return IEmployeeOrganizationInfoDtoFromJSONTyped(json, false);
}

export function IEmployeeOrganizationInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeOrganizationInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'communication_channels': json['communication_channels'] == null ? undefined : new Set(json['communication_channels']),
    };
}

export function IEmployeeOrganizationInfoDtoToJSON(json: any): IEmployeeOrganizationInfoDto {
    return IEmployeeOrganizationInfoDtoToJSONTyped(json, false);
}

export function IEmployeeOrganizationInfoDtoToJSONTyped(value?: IEmployeeOrganizationInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'organization_path': value['organization_path'],
        'communication_channels': value['communication_channels'] == null ? undefined : Array.from(value['communication_channels'] as Set<any>),
    };
}

